module.exports = __webpack_public_path__ + "img/map.e5a1cba0.svg";